import React, { useState, useEffect } from 'react';

// Custom function to parse markdown text
// Custom function to parse markdown text
const customMarkdownParser = (markdown: string): string => {
  // Handle escaped characters (e.g., \.)
  markdown = markdown.replace(/\\([.*+?^=!:${}()|\[\]\/\\])/g, '$1');

  // Normalize line endings
  markdown = markdown.replace(/\r\n/g, '\n');

  // Headings
  markdown = markdown.replace(/^###### (.+)$/gm, '<h6>$1</h6>');
  markdown = markdown.replace(/^##### (.+)$/gm, '<h5>$1</h5>');
  markdown = markdown.replace(/^#### (.+)$/gm, '<h4>$1</h4>');
  markdown = markdown.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  markdown = markdown.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  markdown = markdown.replace(/^# (.+)$/gm, '<h1>$1</h1>');

  // Bold and Italic
  markdown = markdown.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  markdown = markdown.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // Horizontal rules
  markdown = markdown.replace(/^(-{3,}|\*{3,})$/gm, '<hr />');

  // Links
  markdown = markdown.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

  // Ordered list blocks
  markdown = markdown.replace(/(^\d+\..+(?:\n\d+\..+)*)/gm, match => {
    const items = match.split('\n').map(line => {
      const item = line.replace(/^\d+\.\s+/, '');
      return `<li>${item}</li>`;
    });
    return `<ol>${items.join('')}</ol>`;
  });

  // Unordered list blocks
  markdown = markdown.replace(/(^[-*+].+(?:\n[-*+].+)*)/gm, match => {
    const items = match.split('\n').map(line => {
      const item = line.replace(/^[-*+]\s+/, '');
      return `<li>${item}</li>`;
    });
    return `<ul>${items.join('')}</ul>`;
  });
  
    // Images
    markdown = markdown.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" />');

  // Paragraphs — preserve existing HTML blocks
  markdown = markdown
    .split(/\n{2,}/)
    .map(block => {
      const trimmed = block.trim();
      if (
        /^<(h[1-6]|ul|ol|li|hr|a|blockquote|pre|code)/.test(trimmed)
      ) {
        return trimmed;
      }
      return `<p>${trimmed.replace(/\n/g, ' ')}</p>`;
    })
    .join('');

  return markdown;
};

// Function to render markdown
const MarkdownRenderer: React.FC<{ markdownText: string }> = ({ markdownText }) => {
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    const html = customMarkdownParser(markdownText);  // Convert markdown to HTML
    setHtmlContent(html);  // Set the HTML content
  }, [markdownText]);  // Trigger on markdownText change

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default MarkdownRenderer;
